/* Landing de la pelota — comportamiento (prefijo pl-) */
(function () {
  // Aparición al hacer scroll
  var aparecen = document.querySelectorAll('.pl-aparece');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('pl-visible'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    aparecen.forEach(function (el) { io.observe(el); });
  } else {
    aparecen.forEach(function (el) { el.classList.add('pl-visible'); });
  }

  function dinero(centavos, formato) {
    var valor = (centavos / 100).toFixed(2);
    var entero = valor.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var conDecimales = entero + '.' + valor.split('.')[1];
    return (formato || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, entero)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conDecimales.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, conDecimales);
  }

  document.querySelectorAll('[data-pl-comprar]').forEach(function (sec) {
    var datos = sec.querySelector('[data-pl-variantes]');
    if (!datos) return;
    var variantes = JSON.parse(datos.textContent);
    var formato = sec.getAttribute('data-formato');
    var opcionTarjetas = sec.getAttribute('data-opcion-tarjetas');
    var txtAhorras = sec.getAttribute('data-txt-ahorras') || 'Ahorras';
    var txtNormal = sec.getAttribute('data-txt-normal') || '';
    var unidades = {};
    (sec.getAttribute('data-unidades') || '').split(/\n|\r/).forEach(function (l) {
      var p = l.split('='); if (p.length === 2) unidades[p[0].trim()] = parseInt(p[1], 10) || 1;
    });
    var fieldsets = Array.prototype.slice.call(sec.querySelectorAll('[data-pl-opcion]'));
    var idTarjetas = -1;
    fieldsets.forEach(function (fs, i) { if (fs.querySelector('legend').firstChild.textContent.trim() === opcionTarjetas) idTarjetas = i; });

    var inputId = sec.querySelector('[data-pl-id]');
    var precio = sec.querySelector('[data-pl-precio]');
    var tachado = sec.querySelector('[data-pl-tachado]');
    var ahorro = sec.querySelector('[data-pl-ahorro]');
    var boton = sec.querySelector('[data-pl-boton]');
    var aviso = sec.querySelector('[data-pl-aviso]');
    var principal = sec.querySelector('[data-pl-principal]');
    var minis = sec.querySelectorAll('.pl-buy__mini');
    var precioFijo = sec.querySelector('[data-pl-precio-fijo]');

    function elegidos() {
      return fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function buscar(ops) {
      return variantes.find(function (v) { return v.options.every(function (o, i) { return o === ops[i]; }); });
    }
    function precioUnitarioBase(ops) {
      // precio de la variante de 1 unidad con las demás opciones iguales
      if (idTarjetas < 0) return null;
      for (var nombre in unidades) {
        if (unidades[nombre] === 1) {
          var o = ops.slice(); o[idTarjetas] = nombre;
          var v = buscar(o); if (v) return v.price;
        }
      }
      return null;
    }
    function mostrarFoto(mediaId, src) {
      if (!principal || !src) return;
      principal.src = src;
      minis.forEach(function (m) { m.classList.toggle('pl-activo', String(m.getAttribute('data-media-id')) === String(mediaId)); });
    }
    function actualizar(cambiarFoto) {
      var ops = elegidos();
      var v = buscar(ops);
      fieldsets.forEach(function (fs, i) { var s = fs.querySelector('[data-pl-elegido]'); if (s) s.textContent = ops[i]; });
      var base = precioUnitarioBase(ops);
      // Precios de cada tarjeta
      if (idTarjetas >= 0) {
        fieldsets[idTarjetas].querySelectorAll('[data-pl-tarjeta]').forEach(function (lab) {
          var nombre = lab.getAttribute('data-pl-tarjeta');
          var o = ops.slice(); o[idTarjetas] = nombre;
          var vt = buscar(o); var caja = lab.querySelector('[data-pl-tarjeta-precio]');
          if (!vt || !caja) return;
          var n = unidades[nombre] || 1; var html = dinero(vt.price, formato);
          if (base && n > 1 && base * n > vt.price) html = '<s>' + dinero(base * n, formato) + '</s>' + html;
          caja.innerHTML = html;
        });
      }
      if (!v) {
        boton.disabled = true; aviso.textContent = sec.getAttribute('data-no-disponible'); return;
      }
      aviso.textContent = '';
      inputId.value = v.id;
      precio.textContent = dinero(v.price, formato);
      if (precioFijo) precioFijo.textContent = dinero(v.price, formato);
      var n = idTarjetas >= 0 ? (unidades[ops[idTarjetas]] || 1) : 1;
      if (base && n > 1 && base * n > v.price) {
        tachado.textContent = dinero(base * n, formato); tachado.hidden = false;
        tachado.setAttribute('aria-label', txtNormal);
        ahorro.textContent = txtAhorras + ' ' + dinero(base * n - v.price, formato); ahorro.hidden = false;
      } else { tachado.hidden = true; ahorro.hidden = true; }
      boton.disabled = !v.available;
      boton.textContent = v.available ? boton.getAttribute('data-texto') : boton.getAttribute('data-agotado');
      if (cambiarFoto && v.featured_image) mostrarFoto(v.featured_media_id, v.featured_image);
    }
    fieldsets.forEach(function (fs, i) {
      fs.addEventListener('change', function () { actualizar(i !== idTarjetas); });
    });
    minis.forEach(function (m) {
      m.addEventListener('click', function () { mostrarFoto(m.getAttribute('data-media-id'), m.getAttribute('data-src')); });
    });
    actualizar(false);

    // Barra fija en el móvil: aparece cuando el bloque de compra no está a la vista
    var fija = sec.querySelector('[data-pl-fija]');
    if (fija && 'IntersectionObserver' in window) {
      var heroVisto = false;
      new IntersectionObserver(function (e) {
        var dentro = e[0].isIntersecting;
        fija.classList.toggle('pl-visible', !dentro && window.scrollY > 500);
      }, { threshold: 0.05 }).observe(sec.querySelector('.pl-buy__grid'));
      window.addEventListener('scroll', function () {
        var r = sec.querySelector('.pl-buy__grid').getBoundingClientRect();
        var dentro = r.top < window.innerHeight && r.bottom > 0;
        fija.classList.toggle('pl-visible', !dentro && window.scrollY > 500);
      }, { passive: true });
    }
  });
// Interruptor «Sin / Con la pelota»: muestra un panel a la vez
  document.querySelectorAll('[data-pl-interruptor]').forEach(function (sw) {
    var grid = sw.parentNode.querySelector('[data-pl-prob]');
    if (!grid) return;
    var botones = sw.querySelectorAll('[data-lado]');
    function elegir(lado) {
      grid.setAttribute('data-lado', lado);
      sw.setAttribute('data-lado', lado);
      botones.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-lado') === lado ? 'true' : 'false'); });
    }
    botones.forEach(function (b) { b.addEventListener('click', function () { elegir(b.getAttribute('data-lado')); }); });
    sw.hidden = false;
    elegir('malo');
  });
})();
